import { useState, useEffect } from 'react';
import { IUser } from '../interfaces/auth.interface';
import * as Sentry from '@sentry/react';

export function useUserData() {
    const [user, setUser] = useState<IUser | null>(null);

    const updateUser = () => {
        const data = localStorage.getItem('user');
        if (data) {
            const parsedUser = JSON.parse(data);
            setUser(parsedUser);
            Sentry.setUser({
                user: `${parsedUser.full_name}`,
                email: parsedUser.email || '',
            });
        } else {
            setUser(null);
            Sentry.setUser(null);
        }
    };

    useEffect(() => {
        updateUser();

        window.addEventListener('userUpdated', updateUser);
        return () => {
            window.removeEventListener('userUpdated', updateUser);
        };
    }, []);

    return { user, setUser };
}
